// src/utils/userInteraction.js (recommended)
let userInteracted = false;

export const initUserInteractionTracking = () => {
  ["mousemove", "keydown", "scroll", "touchstart"].forEach(evt => {
    window.addEventListener(
      evt,
      () => {
        userInteracted = true;
      },
      { once: true }
    );
  });
};

export const hasUserInteracted = () => userInteracted;
